// templates.js

import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import GestureIcon from "@material-ui/icons/Gesture";
import SchoolIcon from "@material-ui/icons/School";
import TableChartIcon from "@material-ui/icons/TableChart";
import PieChartIcon from "@material-ui/icons/PieChart";

const templates = [
  {
    heading: "Financial Professionals",
    icon: AttachMoneyIcon,
    description: "Professional slide deck for financial experts",
    taskDescription: "Create an outline for a professional slide deck for financial professionals based on the resources provided.",
    tone: "Professional, Engaging, Informative",
    audience: "Financial professionals with 10+ years of experience",
  },
  {
    heading: "Board Executives",
    icon: BusinessCenterIcon,
    description: "Executive presentation for board members",
    taskDescription: "Develop an outline for a professional slide deck for board executives using the resources provided.",
    tone: "Engaging, Informative, Professional",
    audience: "C-level executives in the board of directors",
  },
  {
    heading: "AI Professional",
    icon: GestureIcon,
    description: "Technical module for AI practitioners",
    taskDescription: "Create an outline for a professional module tailored for AI professionals based on the resources provided.",
    tone: "Technical, Informative, Professional",
    audience: "Working professionals in the field of AI",
  },
  {
    heading: "Quant Student",
    icon: SchoolIcon,
    description: "Educational module for finance students",
    taskDescription: "Develop an outline for a professional module for quantitative finance students using the resources provided.",
    tone: "Technical, Informative, Professional",
    audience: "Final-year undergrad or early grad student in quantitative finance",
  },
  {
    heading: "Analyst",
    icon: TableChartIcon,
    description: "Professional module for financial analysts",
    taskDescription: "Create an outline for a professional module for financial analysts based on the provided resources.",
    tone: "Technical, Informative, Professional",
    audience: "Financial analysts with 5+ years of experience",
  },
  {
    heading: "Data Scientist",
    icon: PieChartIcon,
    description: "Technical module for data scientists",
    taskDescription: "Develop an outline for a professional module for data scientists using the resources provided.",
    tone: "Technical, Informative, Professional",
    audience: "Data scientists with 5+ years of experience",
  },
];

export default templates;
